import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from '@/App.tsx';
import { queryConfig } from '@/api/react-query.config.ts';
import { ErrorBoundary } from './providers/ErrorBoundary';

export const AppProviders = () => {
  // State
  const [queryClient] = useState(() => {
    return new QueryClient({
      defaultOptions: queryConfig,
    });
  });

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </HelmetProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
};
